import {
    LocationData,
    PasswordRule,
    SelectOption,
    SignUpContent,
    SignUpRouteConfig,
    SignUpSocialLink,
} from "./SignUpTypes";

export const signUpRoutes: SignUpRouteConfig = {
    home: "/HomePage",
    signIn: "/SignIn",
};

export const signUpContent: SignUpContent = {
    title: "Create an account",
    subtitle: "Join Salar and make every shopping moment simpler.",
    personalSectionTitle: "Personal details",
    locationSectionTitle: "Location & contact",
    securitySectionTitle: "Secure your account",
    fullNamePlaceholder: "Full Name (As per Govt Id)",
    dateOfBirthPlaceholder: "Date of Birth",
    invitationCodePlaceholder: "Invitation Code (Optional)",
    genderPlaceholder: "Select Gender",
    emailPlaceholder: "Enter Email ID",
    countryPlaceholder: "Select Country",
    mobilePlaceholder: "Enter Mobile Number",
    statePlaceholder: "Select State",
    districtPlaceholder: "Select District",
    cityPlaceholder: "Select City",
    pincodePlaceholder: "Enter Pincode",
    passwordPlaceholder: "Enter Password",
    confirmPasswordPlaceholder: "Re-enter Password",
    signUpLabel: "Sign Up",
    signingUpLabel: "Creating account...",
    signInPrompt: "Already have an account?",
    signInLabel: "Sign in",
    socialTitle: "Follow Salar social media official accounts",
    brandAlt: "Salar",
    heroAlt: "Salar shopping experience",
};

export const genderOptions: SelectOption[] = [
    { value: "male", label: "Male" },
    { value: "female", label: "Female" },
    { value: "other", label: "Other" },
    { value: "prefer-not-to-say", label: "Prefer not to say" },
];

export const countryOptions: SelectOption[] = [
    { value: "india", label: "India", flag: "🇮🇳", dialCode: "+91" },
    { value: "uae", label: "United Arab Emirates", flag: "🇦🇪", dialCode: "+971" },
    { value: "usa", label: "United States", flag: "🇺🇸", dialCode: "+1" },
];

export const locationData: LocationData = {
    india: {
        "Andhra Pradesh": {
            Chittoor: ["Chittoor", "Punganur", "Palamaner"],
            Tirupati: ["Tirupati", "Renigunta", "Srikalahasti"],
            Nellore: ["Nellore", "Kavali", "Gudur"],
        },
        Telangana: {
            Hyderabad: ["Hyderabad", "Secunderabad"],
            Rangareddy: ["Gachibowli", "Kondapur", "Shamshabad"],
        },
        Karnataka: {
            Bengaluru: ["Bengaluru", "Whitefield", "Yelahanka"],
            Mysuru: ["Mysuru", "Nanjangud"],
        },
    },
    uae: {
        Dubai: {
            Dubai: ["Downtown Dubai", "Deira", "Jumeirah"],
        },
        "Abu Dhabi": {
            "Abu Dhabi": ["Abu Dhabi City", "Yas Island", "Al Ain"],
        },
    },
    usa: {
        California: {
            "Los Angeles": ["Los Angeles", "Santa Monica"],
            "San Francisco": ["San Francisco", "Oakland"],
        },
        Texas: {
            Austin: ["Austin", "Round Rock"],
            Dallas: ["Dallas", "Irving"],
        },
    },
};

export const passwordRules: PasswordRule[] = [
    { id: "length", label: "At least 8 characters" },
    { id: "special", label: "One special character" },
    { id: "case", label: "Uppercase & lowercase" },
    { id: "number", label: "At least one number" },
];

export const signUpSocialLinks: SignUpSocialLink[] = [
    {
        id: "instagram",
        label: "Instagram",
        href: "https://www.instagram.com",
        iconClass: "bi bi-instagram",
    },
    {
        id: "facebook",
        label: "Facebook",
        href: "https://www.facebook.com",
        iconClass: "bi bi-facebook",
    },
    {
        id: "whatsapp",
        label: "WhatsApp",
        href: "https://www.whatsapp.com",
        iconClass: "bi bi-whatsapp",
    },
    {
        id: "x",
        label: "X",
        href: "https://x.com",
        iconClass: "bi bi-twitter-x",
    },
    {
        id: "youtube",
        label: "YouTube",
        href: "https://www.youtube.com",
        iconClass: "bi bi-youtube",
    },
];
